<template>
  <div class="access-map-info">
    <dl>
      <dt>所在地</dt>
      <dd>
        <p>〒272-0035</p>
        <p>千葉県市川市新田5-5-29 トーオービル202号室</p>
        <p class="note">＊1階HANJA GYMさん横の階段をお上がりください</p>
      </dd>
    </dl>
    <dl>
      <dt>電車</dt>
      <dd>
        <p>JR総武線 市川駅 北口から徒歩8分</p>
        <p>京成線 市川真間駅 南口から徒歩1分</p>
      </dd>
    </dl>
    <dl>
      <dt>駐車場</dt>
      <dd>なし<span class="note">※近隣コインパーキングをご利用ください</span></dd>
    </dl>
    <dl>
      <dt>駐輪場</dt>
      <dd>あり<span class="note">※ビル1Fの駐輪場をご利用ください</span></dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'Hapi-AccessInfo',
}
</script>
